import css from '../sass/public.scss';

import 'bootstrap';
import smoothscroll from 'smoothscroll-polyfill';

smoothscroll.polyfill();

'use strict';

(function($) {


	$(document).on('ready', function() {

		$.crownTheme.initScrollReveal();

		$.crownTheme.initMobileMenu();
		$.crownTheme.initAnchorLinks();
		$.crownTheme.initOdometers();
		$.crownTheme.initSliders();
		$.crownTheme.initFlushContainers();
		$.crownTheme.initTeamMembers();
		$.crownTheme.initProcessOverview();

	});


	$.crownTheme = (function(crownTheme) {


		crownTheme.initScrollReveal = function() {

			var scrollRevealElements = function() {
				var scrollTop = $(window).scrollTop();
				var windowHeight = $(window).height();
				var elements = $('#main-content > .page-section#main-header, #main-article > .page-section#main-header');
				elements.filter(':not(.revealed)');
				elements.each(function(i, el) {
					var element = $(el);
					if(scrollTop + windowHeight * .8 >= element.offset().top) {
						element.addClass('revealed');
					}
				});
			};
			
			setTimeout(function() {
				scrollRevealElements();
				$(window).on('scroll resize load', scrollRevealElements);
			}, 0);

		};


		crownTheme.initMobileMenu = function() {
			$(document).on('mobile-menu-open', function(e) {
				$('body').addClass('mobile-menu-active');
			});
			$(document).on('mobile-menu-close', function(e) {
				$('body').removeClass('mobile-menu-active');
			});
			$(document).on('mobile-menu-toggle', function(e) {
				$('body').toggleClass('mobile-menu-active');
			});
			$(document).on('touchstart click', 'body.mobile-menu-active #page', function(e) {
				if($(e.target).closest('#mobile-menu-toggle').length) return;
				$(document).trigger('mobile-menu-close');
			});
			$('#mobile-menu-toggle').on('click', function(e) {
				$(document).trigger('mobile-menu-toggle');
			});
		};


		crownTheme.initAnchorLinks = function() {
			$(document).on('click', '.next-section-link', function(e) {
				e.preventDefault();
				var currentSection = $(this).closest('.page-section');
				crownTheme.smoothScrollToPos(currentSection.offset().top + currentSection.outerHeight());
			});
			$(document).on('click', '.return-to-top-link', function(e) {
				e.preventDefault();
				crownTheme.smoothScrollToPos(0);
			});
			$(document).on('click', '.anchor-link', function(e) {
				if(!$(this).attr('href').match(/^#/)) return;
				var element = $($(this).attr('href'));
				if(element.length) {
					e.preventDefault();
					crownTheme.smoothScrollToPos(element.offset().top);
				}
			});
		};


		crownTheme.initOdometers = function() {

			$('.stat').each(function(i, el) {
				var value = $(el);
				$(el).addClass('fade-in');
				var matches = value.text().match(/([^\d]*)([\d\.,]+)(.*)/);
				if(matches) {

					value.data('odometer-final-value', matches[2]);

					var preOd = $('<span class="pre">' + matches[1] + '</span>');
					var odometer = $('<span class="odometer">' + matches[2] + '</span>');
					var postOd = $('<span class="post">' + matches[3] + '</span>');
					value.html('');
					value.append(preOd).append(odometer).append(postOd);
					
					var od = new Odometer({ el: odometer[0], value: '0'.padStart(5, 0) });

				}
			});

			var animateStats = function() {
				var scrollTop = $(window).scrollTop();
				var windowHeight = $(window).height();
				$('.stat.fade-in:not(.animated)').each(function(i, el) {
					var value = $(el);
					if(value.offset().top <= scrollTop + (windowHeight * .9)) {
						$(el).addClass('animated');
						$('.odometer', value).text(value.data('odometer-final-value'));
					}
				});
			};
			animateStats();
			$(window).on('load scroll resize', animateStats);

		};


		crownTheme.initSliders = function() {

			$('.img-slider').each(function(i, el) {
				var slider = $(el);
				if(slider.hasClass('slick-initialized')) return;

				var slickSettings = {
					mobileFirst: true,
					draggable: true,
					dots: true,
					arrows: false,
					fade: true,
					autoplay: false,
					autoplaySpeed: 3000,
					responsive: [
						{ breakpoint: 768 - 1,  settings: { dots: true } },
					]
				};

				var id = slider.attr('id');
				var toggles = id ? $('[data-img-slider-toggle-id="' + id + '"]') : null;
				if(toggles && toggles.length) {
					toggles.on('mouseenter mousemove', function(e) {
						if(window.innerWidth >= 768) {
							var slider = $('#' + $(this).data('img-slider-toggle-id'));
							if(slider.length) {
								var currentSlide = slider.slick('slickCurrentSlide');
								var slide = parseInt($(this).data('img-slider-toggle-slide')) - 1;
								if(currentSlide != slide) {
									slider.slick('slickSetOption', 'speed', 100).slick('slickPause').slick('slickGoTo', currentSlide, true).slick('slickGoTo', slide);
								}
							}
						}
					});
					slider.on('init', function(e, slick) {
						var id = slick.$slider.attr('id');
						var toggles = id ? $('[data-img-slider-toggle-id="' + id + '"]') : null;
						if(toggles && toggles.length) {
							toggles.removeClass('active');
							var currentToggle = toggles.filter('[data-img-slider-toggle-slide="1"]');
							currentToggle.addClass('active');
						}
					}).on('beforeChange', function(e, slick, currentSlide, nextSlide) {
						var id = slick.$slider.attr('id');
						var toggles = id ? $('[data-img-slider-toggle-id="' + id + '"]') : null;
						if(toggles && toggles.length) {
							toggles.removeClass('active');
							var currentToggle = toggles.filter('[data-img-slider-toggle-slide="' + (nextSlide + 1) + '"]');
							currentToggle.addClass('active');
						}
					});
				}

				slider.on('setPosition', function(event, slick) {
					var track = $('.slick-track', slick.$slider);
					var slides = $('.slick-slide', slick.$slider);
					slides.css({ height: 'auto' });
					slides.css({ height: track.height() });
				}).slick(slickSettings);
			});

		};


		crownTheme.initFlushContainers = function() {
			var adjustFlushContainers = function() {
				var bodyWidth = $('body').width();
				var bodyOffsetLeft = $('#page').offset().left;
				$('.flush-right-container').each(function(i, el) {
					var container = $(el);
					container.css({ marginRight: 0 });
					var margin = bodyWidth - container.offset().left + bodyOffsetLeft - container.outerWidth();
					container.css({ marginRight: -margin });
				});
			};
			adjustFlushContainers();
			$(window).on('load resize', adjustFlushContainers);
		};


		crownTheme.initTeamMembers = function() {
			$(document).on('click', '.team-member > .inner', function(e) {
				if($(e.target).is('button.close')) return;
				var teamMember = $(this).closest('.team-member');
				if(teamMember.hasClass('active')) return;
				teamMember.addClass('active');
				var overviewHeight = $('.overview', teamMember).outerHeight();
				$('.details', teamMember).css({ height: overviewHeight });
				setTimeout(function() { $('.details', teamMember).css({ height: 'calc(100% + 4px)' }); }, 0);
			});
			$(document).on('click', '.team-member button.close', function(e) {
				var teamMember = $(this).closest('.team-member');
				teamMember.removeClass('active');
				var overviewHeight = $('.overview', teamMember).outerHeight();
				$('.details', teamMember).css({ height: overviewHeight });
				setTimeout(function() { $('.details', teamMember).css({ height: 'auto' }); }, 200);
			});
			var adjustTeamMembers = function() {
				$('.team-member-grid .team-member:first-child').each(function(i, el) {
					$(el).parent().find('.team-member').each(function(j, el2) {
						var overviewHeight = $('.overview', el2).outerHeight();
						$('.details', el2).css({ minHeight: overviewHeight });
						$(el2).addClass('initialized');
					});
					var width = $('.bio', el).outerWidth();
					var fontSize = Math.min(1, width / 228);
					$(el).parent().find('.team-member .bio').css({ fontSize: fontSize + 'rem' });
				});
			};
			adjustTeamMembers();
			$(window).on('load resize', adjustTeamMembers);
		};


		crownTheme.initProcessOverview = function() {
			if(!$('.process-overview').length) return;

			var updateProcessOverviewActivePhase = function() {
				var scrollTop = $(window).scrollTop();
				var windowHeight = $(window).height();
				var phases = $('.process-overview .phase');
				var activePhase = phases.first();
				phases.each(function(i, el) {
					var phase = $(el);
					if(scrollTop + windowHeight * .5 >= phase.offset().top) {
						activePhase = phase;
					}
				});
				if(!activePhase.hasClass('active')) {
					$('.process-overview .graphic').removeClass(phases.filter('.active').data('phase'));
					phases.filter('.active').removeClass('active');
					activePhase.addClass('active');
					$('.process-overview .graphic').addClass(activePhase.data('phase'));
				}
			};
			
			setTimeout(function() {
				updateProcessOverviewActivePhase();
				$(window).on('scroll resize load', updateProcessOverviewActivePhase);
			}, 0);

		};


		crownTheme.smoothScrollToElement = function(element, speed, offset) {
			speed = typeof speed !== 'undefined' ? speed : 1000;
			offset = typeof offset !== 'undefined' ? offset : 0;
			if(element.length > 0) {
				var margin = parseInt(element.css('margin-top'));
				crownTheme.smoothScrollToPos(element.offset().top - (margin > 0 ? margin : 0), speed, offset);
			}
		};
		crownTheme.smoothScrollToPos = function(y, speed, offset) {
			speed = typeof speed !== 'undefined' ? speed : 1000;
			offset = typeof offset !== 'undefined' ? offset : 0;
			var fixedHeaderOffset = $('#page').offset().top;
			// $('html, body').stop(true).animate({ scrollTop: y - fixedHeaderOffset + offset - 12 }, speed, 'easeOutExpo');
			window.scrollTo({ top: y - fixedHeaderOffset + offset, behavior: 'smooth' });
		};
	

		return crownTheme;
		
	})({});


})(jQuery);
